import type { AttributeProps } from '../Attribute/Attribute.types';
import type { BadgeProps } from '../Badge/Badge.types';
import type { ButtonProps } from '../Button/Button.types';
import type { FeedbackMessageProps } from '../FeedbackMessage/FeedbackMessage.types';

export type HighlightCardFeedbackProps = Omit<
  FeedbackMessageProps,
  'mode' | 'fullWidth' | 'buttonText'
>;

export const HighlightCardBackground = {
  BASE: 'base',
  RAISED: 'raised',
  SUBTLE: 'subtle',
  IDLE: 'idle',
} as const;

export type HighlightCardBackgroundType =
  (typeof HighlightCardBackground)[keyof typeof HighlightCardBackground];

export const HighlightCardStripeTone = {
  BRAND: 'brand',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

export type HighlightCardStripeToneType =
  (typeof HighlightCardStripeTone)[keyof typeof HighlightCardStripeTone];

export type HighlightCardTitleLevel = 2 | 3 | 4 | 5 | 6;

export const HighlightCardDescriptionEmphasis = {
  CAPTION: 'caption',
  BODY: 'body',
} as const;

export type HighlightCardDescriptionEmphasisType =
  (typeof HighlightCardDescriptionEmphasis)[keyof typeof HighlightCardDescriptionEmphasis];

export const HighlightCardLeadingSize = {
  AUTO: 'auto',
  BANNER: 'banner',
  PREVIEW: 'preview',
} as const;

export type HighlightCardLeadingSizeType =
  (typeof HighlightCardLeadingSize)[keyof typeof HighlightCardLeadingSize];

export type HighlightCardActionProps = ButtonProps & {
  label?: string;
};

export type HighlightCardProps = {
  highlighted?: boolean;
  stripeTone?: HighlightCardStripeToneType;
  padded?: boolean;
  backgroundColor?: HighlightCardBackgroundType;
  title?: string;
  titleLevel?: HighlightCardTitleLevel;
  description?: string;
  descriptionEmphasis?: HighlightCardDescriptionEmphasisType;
  badge?: BadgeProps;
  attribute?: AttributeProps;
  feedbackMessage?: HighlightCardFeedbackProps;
  leadingSrc?: string;
  leadingAlt?: string;
  leadingSize?: HighlightCardLeadingSizeType;
  action?: HighlightCardActionProps;
  actions?: HighlightCardActionProps[];
  headerActions?: HighlightCardActionProps[];
  inlineAction?: HighlightCardActionProps;
  testId?: string;
};
